import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { NinaForm } from '../../components/NinaForm.js';
import { Button } from '../../components/ui/Button.js';
import { Card, CardBody, CardHeader, CardTitle } from '../../components/ui/Card.js';
import { FwaApiError } from '../../lib/api.js';
import { useCreateNina } from '../../lib/queries/ninas.js';

export function NinasNew() {
  const navigate = useNavigate();
  const mutation = useCreateNina();
  const [serverError, setServerError] = useState<string>('');

  return (
    <div className="space-y-4 max-w-2xl">
      <h1 className="text-2xl font-semibold text-gray-900">Alta de niña</h1>

      <Card>
        <CardHeader>
          <CardTitle>Datos generales</CardTitle>
        </CardHeader>
        <CardBody>
          <NinaForm
            mode="create"
            onSubmit={(payload) => {
              setServerError('');
              mutation.mutate(payload, {
                onSuccess: (res) => {
                  if ('queuedOffline' in res) {
                    navigate('/outbox');
                    return;
                  }
                  navigate(`/ninas/${res.data.entity_id}`);
                },
                onError: (err) => {
                  if (err instanceof FwaApiError) {
                    setServerError(err.problem.detail ?? err.problem.title);
                  } else {
                    setServerError(err.message);
                  }
                },
              });
            }}
            isSubmitting={mutation.isPending}
            serverError={serverError}
          />
        </CardBody>
      </Card>

      <Link to="/ninas">
        <Button variant="ghost">← Regresar al padrón</Button>
      </Link>
    </div>
  );
}
